import { render, staticRenderFns } from "./pay-details.vue?vue&type=template&id=377f8356&scoped=true"
import script from "./pay-details.vue?vue&type=script&lang=js"
export * from "./pay-details.vue?vue&type=script&lang=js"
import style0 from "./pay-details.vue?vue&type=style&index=0&id=377f8356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f8356",
  null
  
)

export default component.exports